import { Routes } from '@angular/router';

export const serviceRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./services/services.component').then((m) => m.ServicesComponent),
  },
  {
    path: 'service-ios',
    loadComponent: () =>
      import('./services-app/service-ios/service-ios.component').then((m) => m.ServiceIosComponent),
  },
  {
    path: 'service-android',
    loadComponent: () =>
      import('./services-app/service-android/service-android.component').then(
        (m) => m.ServiceAndroidComponent
      ),
  },
  {
    path: 'service-flutter',
    loadComponent: () =>
      import('./services-app/service-flutter/service-flutter.component').then(
        (m) => m.ServiceFlutterComponent
      ),
  },
  {
    path: 'service-ui-ux',
    loadComponent: () =>
      import('./services-web/service-ui-ux/service-ui-ux.component').then(
        (m) => m.ServiceUiUxComponent
      ),
  },
  {
    path: 'service-development',
    loadComponent: () =>
      import('./services-web/service-development/service-development.component').then(
        (m) => m.ServiceDevelopmentComponent
      ),
  },
  {
    path: 'service-e-commerce',
    loadComponent: () =>
      import('./services-web/service-e-commerce/service-e-commerce.component').then(
        (m) => m.ServiceECommerceComponent
      ),
  },
  {
    path: 'service-wordpress',
    loadComponent: () =>
      import('./services-web/service-wordpress/service-wordpress.component').then(
        (m) => m.ServiceWordpressComponent
      ),
  },
  {
    path: 'service-crm',
    loadComponent: () =>
      import('./services-software/service-crm/service-crm.component').then(
        (m) => m.ServiceCrmComponent
      ),
  },
  {
    path: 'service-hrm',
    loadComponent: () =>
      import('./services-software/service-hrm/service-hrm.component').then(
        (m) => m.ServiceHrmComponent
      ),
  },
  {
    path: 'service-fintech',
    loadComponent: () =>
      import('./services-software/service-fintech/service-fintech.component').then(
        (m) => m.ServiceFintechComponent
      ),
  },
  {
    path: 'service-delivery-apps',
    loadComponent: () =>
      import('./services-software/service-delivery-apps/service-delivery-apps.component').then(
        (m) => m.ServiceDeliveryAppsComponent
      ),
  },
  {
    path: 'service-payroll',
    loadComponent: () =>
      import('./services-software/service-payroll/service-payroll.component').then(
        (m) => m.ServicePayrollComponent
      ),
  },
  {
    path: 'service-seo',
    loadComponent: () =>
      import('./services-contant/service-seo/service-seo.component').then(
        (m) => m.ServiceSeoComponent
      ),
  },
  {
    path: 'service-blogs',
    loadComponent: () =>
      import('./services-contant/service-blogs/service-blogs.component').then(
        (m) => m.ServiceBlogsComponent
      ),
  },
  {
    path: 'service-social-media',
    loadComponent: () =>
      import('./services-contant/service-social-media/service-social-media.component').then(
        (m) => m.ServiceSocialMediaComponent
      ),
  },
];
